import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { resetPasswordRequest } from 'api/aaaService';
import { makeAutoObservable } from 'mobx';
import { RootStore } from 'store/rootStore';
import { ResetPasswordParams } from 'types/aaaService';

interface FormFields extends DefaultFormFields {
  password: FormControl<string>;
  repeatPassword: FormControl<string>;
}

export default class ResetPasswordStore {
  rootStore: RootStore;
  loading = false;
  resetPasswordForm: FormController<FormFields>;
  errorCode: number | null = null;
  showPasswordRecoveryModal = false;

  setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  setShowPasswordRecoveryModal(status: boolean): void {
    this.showPasswordRecoveryModal = status;
  }

  setErrorCode(error: number | null): void {
    this.errorCode = error;
  }

  async resetPassword(email: string, uuidCode: string): Promise<void> {
    this.setErrorCode(null);

    this.setLoading(true);
    const data = {
      email,
      password: this.resetPasswordForm.fields.password.value,
      uuidCode,
    };
    const res = await this.rootStore.requestProcessor.processRequest<string, ResetPasswordParams>(
      resetPasswordRequest,
      data,
    );
    if (res?.status === 200) {
      this.setShowPasswordRecoveryModal(true);
    } else {
      this.setErrorCode(res?.status || null);
    }
    this.setLoading(false);
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    // Field is not optional, but required validations should not be shown for empty field
    this.resetPasswordForm = new FormController({
      password: new FormControl<string>('', { validations: ['isPasswordStrong'], optional: true }),
      repeatPassword: new FormControl<string>('', { optional: true }),
    });
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
